import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Wrapper>
      <div className="rs-footer-bg-thumb-wrapper has-theme-orange">
        <div
          className="rs-footer-bg-thumb"
          style={{
            backgroundImage: "url('/assets/images/bg/footer-bg-02.png')",
          }}
        ></div>

        {/* <div className="rs-subscribe-area rs-subscribe-one has-theme-orange">
        <div className="container">
          <div className="rs-subscribe-wrapper">
            <div className="row g-5 align-items-center">
              <div className="col-xl-3 col-lg-3">
                <div className="rs-subscribe-logo">
                  <img
                    src="/assets/images/logo/logo-orange-white.png"
                    alt="imagee"
                  />
                </div>
              </div>
              <div className="col-xl-9 col-lg-9">
                <div className="rs-subscribe-content">
                  <div className="rs-subscribe-text">
                    <p>
                      Subscribe for the latest news. Stay updated on the latest
                      trends.
                    </p>
                  </div>
                  <div className="rs-subscribe-input">
                    <input
                      name="name"
                      type="text"
                      placeholder="Enter Your Email"
                    />
                    <button type="submit" className="rs-btn has-theme-orange">
                      Send Message
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

        <footer>
          <div className="rs-footer-area rs-footer-two has-theme-orange">
            <div className="container">
              <div className="rs-footer-top">
                <div className="row g-5">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6">
                    <div className="rs-footer-widget footer-2-col-1">
                      <h5 className="rs-footer-widget-title">About Company</h5>
                      <div className="rs-footer-widget-content">
                        <p className="rs-footer-widget-description">
                          It was popularised in the 1960s with the release of
                          Letraset sheets containing Lorem Ipsums.
                        </p>
                        <div className="rs-footer-widget-stroke-text">
                          <h3 className="rs-footer-stroke-text has-theme-orange">
                            Since 2007
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6">
                    <div className="rs-footer-widget footer-2-col-2">
                      <h5 className="rs-footer-widget-title">Useful Links</h5>
                      <div className="rs-footer-widget-content">
                        <div className="rs-footer-widget-links has-theme-orange">
                          <ul>
                            <li>
                              <Link to="/">Home</Link>
                            </li>
                            <li>
                              <Link to="/about">About</Link>
                            </li>
                            <li>
                              <Link to="#">Net & Roop</Link>
                            </li>
                            <li>
                              <Link to="/products">Products</Link>
                            </li>
                            <li>
                              <Link to="/awards">Awards</Link>
                            </li>
                            <li>
                              <Link to="/certification">Certification</Link>
                            </li>
                            <li>
                              <Link to="#">Media</Link>
                            </li>
                            <li>
                              <Link to="#">Act & Policies</Link>
                            </li>
                            <li>
                              <Link to="/contact">Contact</Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6">
                    <div className="rs-footer-widget footer-2-col-3">
                      <h5 className="rs-footer-widget-title">Office Address</h5>
                      <div className="rs-footer-widget-content">
                        <div className="rs-footer-widget-meta">
                          <div className="rs-footer-widget-address">
                            <Link
                              target="_blank"
                              rel="noopener noreferrer"
                              to="https://www.google.com/maps"
                            >
                              {/* Plot No 03-04, Sector N0-01,Uttara EPZ, Nilphamari
                              5300, Bangladesh. */}
                              Holding # 27, Aminul Haque Road, New Babupara,
                              Saidpur, Nilphamari-5300, Bangladesh.
                            </Link>
                          </div>
                          <h5 className="rs-footer-widget-title">
                            Email Address
                          </h5>
                          {/* <p>Interested in working with us?</p> */}
                          <div className="rs-footer-widget-email">
                            <Link to="mailto:equeinternational@gmail.com">
                              equeinternational@gmail.com
                            </Link>
                          </div>
                          <div className="rs-footer-widget-email">
                            <Link to="mailto:zahid@equeinternational.com">
                              zahid@equeinternational.com
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6">
                    <div className="rs-footer-widget footer-2-col-4">
                      <h5 className="rs-footer-widget-title">Phone Number</h5>
                      <div className="rs-footer-widget-content">
                        <div className="rs-footer-widget-contact-info">
                          <div className="rs-footer-widget-number">
                            <span>
                              <Link to="tel:01833688844">01833688844</Link>
                            </span>
                            <span>
                              <Link to="tel:01611001022">01611001022</Link>
                            </span>
                          </div>
                        </div>
                        <h5 className="rs-footer-widget-title">Follow Us</h5>
                        <div className="rs-footer-widget-social">
                          <div className="rs-theme-social has-theme-orange">
                            <Link to="#">
                              <i className="ri-facebook-fill"></i>
                            </Link>
                            <Link to="#">
                              <i className="ri-twitter-x-line"></i>
                            </Link>
                            <Link to="#">
                              <i className="ri-linkedin-fill"></i>
                            </Link>
                            <Link to="#">
                              <i className="ri-instagram-line"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="rs-footer-copyright-area rs-copyright-one">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-xl-12">
                    <div className="rs-footer-copyright has-theme-orange text-center">
                      <p className="underline">
                        © <span id="year">{currentYear}</span> Eque
                        International. Designed & Developed by &nbsp;
                        <Link
                          to="https://www.ekattorit.com/"
                          className="fw-bold footer-text"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span style={{ color: "red" }}>EKATTOR</span>
                          <span style={{ color: "green" }}> iT</span>
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .rs-footer-widget-links ul {
    display: block; /* or remove display:grid */
    list-style: none;
    padding: 0;
  }

  .rs-footer-widget-links ul li {
    display: block;
    margin-bottom: 8px;
  }
`;

export default Footer;

// import React from "react";
// import { Link } from "react-router-dom";

// const Footer = () => {
//   const currentYear = new Date().getFullYear();

//   return (
//     <footer class="rs-footer-area rs-footer-one black-bg">
//       <div
//         class="rs-footer-bg-thumb"
//         data-background="assets/images/bg/footer-bg-01.png"
//       ></div>
//       <div class="container">
//         <div class="rs-footer-wrapper">
//           <div class="rs-footer-item">
//             <div class="rs-footer-widget footer-1-col-1">
//               <div class="rs-footer-widget-logo">
//                 <Link to="index.html">
//                   <img
//                     src="/assets/images/logo/logo-orange-white.png"
//                     alt="logo"
//                   />
//                 </Link>
//               </div>
//               <div class="rs-footer-widget-content">
//                 <p class="rs-footer-widget-description">
//                   It was popularised in the 1960s with the release of Letraset
//                   sheets containing Lorem Ipsum passages, and more recently
//                   works.
//                 </p>
//                 <div class="rs-footer-widget-stroke-text">
//                   <h3 class="rs-footer-stroke-text">Since 2007</h3>
//                 </div>
//                 <div class="rs-footer-copyright underline">
//                   <p>
//                     © <span id="year">{currentYear}</span> Eque Group. Designed
//                     & Developed by &nbsp;
//                     <Link to="https://www.ekattorit.com/">EKATTOR iT</Link>
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div class="rs-footer-item">
//             <div class="rs-footer-widget footer-1-col-2">
//               <h5 class="rs-footer-widget-title">Useful Links</h5>
//               <div class="rs-footer-widget-content">
//                 <div class="rs-footer-widget-links">
//                   <ul>
//                     <li>
//                       <Link to="#">About Us</Link>
//                     </li>
//                     <li>
//                       <Link to="#">Projects</Link>
//                     </li>
//                     <li>
//                       <Link to="#">Careers</Link>
//                     </li>
//                     <li>
//                       <Link to="#">Blog</Link>
//                     </li>
//                     <li>
//                       <Link to="#">Privacy Policy</Link>
//                     </li>
//                     <li>
//                       <Link to="#">Services</Link>
//                     </li>
//                     <li>
//                       <Link to="#">Pricing</Link>
//                     </li>
//                     <li>
//                       <Link to="#">Team</Link>
//                     </li>
//                     <li>
//                       <Link to="#">Contact</Link>
//                     </li>
//                     <li>
//                       <Link to="#">Terms of use</Link>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div class="rs-footer-item">
//             <div class="rs-footer-widget footer-1-col-3">
//               <h5 class="rs-footer-widget-title">Newsletter</h5>
//               <div class="rs-footer-widget-content">
//                 <p class="descrip">
//                   Subscribe for the latest news. Stay updated on the latest
//                   trends industrie.
//                 </p>
//                 <form action="#">
//                   <div class="rs-footer-subscribe-input">
//                     <input type="email" placeholder="Enter Your Email" />
//                   </div>
//                 </form>
//                 <div class="rs-footer-btn">
//                   <button
//                     type="submit"
//                     class="rs-btn has-theme-orange has-icon has-bg"
//                   >
//                     Subscribe Now
//                     <span class="icon-box">
//                       <svg
//                         class="icon-first"
//                         xmlns="http://www.w3.org/2000/svg"
//                         viewBox="0 0 32 32"
//                       >
//                         <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
//                       </svg>
//                       <svg
//                         class="icon-second"
//                         xmlns="http://www.w3.org/2000/svg"
//                         viewBox="0 0 32 32"
//                       >
//                         <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
//                       </svg>
//                     </span>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
